import { render, staticRenderFns } from "./stainlessSteelPanel.vue?vue&type=template&id=8ff6700e&scoped=true"
import script from "./stainlessSteelPanel.vue?vue&type=script&lang=js"
export * from "./stainlessSteelPanel.vue?vue&type=script&lang=js"
import style0 from "./stainlessSteelPanel.vue?vue&type=style&index=0&id=8ff6700e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff6700e",
  null
  
)

export default component.exports